const globalUtils = {
  isLogin: false,
  isCustomer: false,
  socialType: 0,
  userInfo: null,
};

export default globalUtils;
